import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { CruiseService } from '../services/cruise.service';
import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { PlatformLocation, isPlatformServer, isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-voucher',
  templateUrl: './cruise-voucher.component.html',
  styleUrls: []
})
export class VoucherComponent implements OnInit {

  public queryData = {
    userlogin: '',
    dateupto: ''
  };
  public Cruisedata: any = {};
  public paxdata: any = {};
  public bookingList: any = {};
  public pipe: DatePipe = new DatePipe('en-US');
  private baseURL: any = ''; private merchantURL: any = '';
  private merchantsetup: any = {};
  private systemsetup: any = {};
  private queryStr: any = '';
  public transactionId: any;
  private useremail: any = ''; public otpCode: any = ''; private profileData: any = {};

  constructor(@Inject(PLATFORM_ID) private platformId: Object, private loginService: CruiseService, private toastr: ToastrService, private route: ActivatedRoute, private router: Router, platformLocation: PlatformLocation) {
    this.route.params.subscribe(
      data => {
        this.transactionId = data.txId;
      })
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (sessionStorage.getItem("cruisebookingList")) {
        this.bookingList = JSON.parse(sessionStorage.getItem("cruisebookingList"));
        this.Cruisedata = this.loginService.getDecrypt(this.bookingList.cruiseData);
        this.paxdata = this.loginService.getDecrypt(this.bookingList.agentData);
      }
    }
  }

}
